import { render, staticRenderFns } from "./foodCourtTable.vue?vue&type=template&id=02da5834&scoped=true&"
import script from "./foodCourtTable.vue?vue&type=script&lang=js&"
export * from "./foodCourtTable.vue?vue&type=script&lang=js&"
import style0 from "./foodCourtTable.vue?vue&type=style&index=0&id=02da5834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02da5834",
  null
  
)

export default component.exports